import { Component, OnInit, Input } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';
import { BaseSelectable } from '../selectable.base';
import { TranslateService } from '@ngx-translate/core';

export interface SingleSelectionItem {
  selectedValue: any;
  options: { label: string; value: any; dealerPerorgNo?: number; sellerGroupId?: number }[];
  allowCancel?: boolean;
}
export interface SingleSelectionItemOption {
  label: string;
  value: any;
}
export interface SingleSelectedItemResult {
  value: string;
}

@Component({
  selector: 'iq-single-selection-list',
  templateUrl: './single-selection-list.component.html',
  styleUrls: [
    './single-selection-list.component.scss',
    '../selectable-list/selectable-list.component.scss'
  ]
})
export class SingleSelectionListComponent
  extends BaseSelectable<SingleSelectedItemResult>
  implements OnInit {
  private _singleSelectionItem: SingleSelectionItem;
  @Input()
  public get singleSelectionItem() {
    return this._singleSelectionItem;
  }

  public set singleSelectionItem(val: SingleSelectionItem) {
    this._singleSelectionItem = val;
    this.updateSelection();
  }

  selectedOption: FormControl;
  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    super();
  }

  submit(event: Event) {
    if (this.formGroup.valid) {
      this.errorMessage = null;
      this.validSelection.emit({
        result: { value: this.selectedOption.value }
      });
    } else {
      this.errorMessage = this.translateService.instant(this.errorCode);
    }
  }

  ngOnInit() {
    this.updateSelection();
  }

  private updateSelection() {
    this.selectedOption = this.formBuilder.control(
      this.singleSelectionItem.selectedValue,
      [Validators.required]
    );
    this.formGroup = this.formBuilder.group({
      selectedOption: this.selectedOption
    });
  }
}
